import React from "react";
import "../Styles/Pricing.scss";
import {
  User,
  Users,
  Send,
  Database,
  Globe,
  Check,
  ArrowRight,
  Star,
} from "lucide-react";

const masterPlansData = [
  {
    id: "advantage",
    name: "ADVANTAGE",
    price: 399,
    period: "month",
    conversations: "2,000 conversations / month",
    popular: false,
    users: "10 users",
    agents: "4 live agents",
    broadcasts: "100,000 broadcasts / month",
    storage: "75 GB storage",
    languages: "3 agent languages",
    features: [
      { label: "Text", active: true },
      { label: "Image", active: true },
      { label: "Handwriting", active: true },
      { label: "Voice", active: true },
    ],
  },
  {
    id: "premium",
    name: "PREMIUM",
    price: 599,
    period: "month",
    conversations: "3,000 conversations / month",
    popular: true,
    users: "15 users",
    agents: "6 live agents",
    broadcasts: "200,000 broadcasts / month",
    storage: "100 GB storage",
    languages: "5 agent languages",
    features: [
      { label: "Text", active: true },
      { label: "Image", active: true },
      { label: "Handwriting", active: true },
      { label: "Voice", active: true },
    ],
  },
  {
    id: "ultimate",
    name: "ULTIMATE",
    price: 899,
    period: "month",
    conversations: "5,000 conversations / month",
    popular: false,
    users: "25 users",
    agents: "10 live agents",
    broadcasts: "Unlimited broadcasts",
    storage: "150 GB storage",
    languages: "10 agent languages",
    features: [
      { label: "Text", active: true },
      { label: "Image", active: true },
      { label: "Handwriting", active: true },
      { label: "Voice", active: true },
    ],
  },
];

const Pricing = ({ content }) => {
  const plans = masterPlansData;

  return (
    <div className="pricing-wrapper">
      <div className="pricing-section">
        {/* Apple Editorial Header Meta */}
        <div className="pricing-header-meta">
          <span className="pricing-label-apple">PRICING</span>
          <h2 className="pricing-main-title">Flexible plans built for growth</h2>
          <p className="pricing-main-sub">
            Scale your enterprise AI capabilities with predictable, transparent pricing.
          </p>
        </div>

        {/* Apple Spatial Ceramic Cards 3-Column Grid */}
        <div className="pricing-grid">
          {plans.map((plan) => (
            <div
              key={plan.id || plan.name}
              className={`pricing-card ${plan.popular ? "popular" : ""}`}
            >
              {/* Floating Popular Badge Attached at Top Center */}
              {plan.popular && (
                <div className="pricing-popular-badge">
                  <Star size={12} fill="#F05742" color="#F05742" className="pricing-badge-star" />
                  <span>MOST POPULAR</span>
                </div>
              )}

              {/* Plan Header & Price Staging */}
              <div className="pricing-card-header">
                <span className={`pricing-plan-title ${plan.popular ? "coral" : ""}`}>
                  {plan.name}
                </span>

                <div className="pricing-price-stage">
                  <span className="pricing-amount">${plan.price}</span>
                  <span className="pricing-period">/ month</span>
                </div>

                <div className="pricing-conversation-pill">
                  {plan.conversations}
                </div>
              </div>

              {/* Structured Metric Spec Rows */}
              <div className="pricing-spec-rows">
                {/* Row 1: Users & Live Agents */}
                <div className="pricing-spec-dual-row">
                  <div className="pricing-spec-item">
                    <span className="spec-icon-circle">
                      <User size={15} strokeWidth={1.8} />
                    </span>
                    <span className="spec-text font-semibold">{plan.users}</span>
                  </div>
                  <div className="pricing-spec-item">
                    <span className="spec-icon-circle">
                      <Users size={15} strokeWidth={1.8} />
                    </span>
                    <span className="spec-text font-semibold">{plan.agents}</span>
                  </div>
                </div>

                {/* Row 2: Broadcasts */}
                <div className="pricing-spec-item">
                  <span className="spec-icon-circle">
                    <Send size={14} strokeWidth={1.8} />
                  </span>
                  <span className="spec-text">{plan.broadcasts}</span>
                </div>

                {/* Row 3: Storage */}
                <div className="pricing-spec-item">
                  <span className="spec-icon-circle">
                    <Database size={14} strokeWidth={1.8} />
                  </span>
                  <span className="spec-text">{plan.storage}</span>
                </div>

                {/* Row 4: Languages */}
                <div className="pricing-spec-item">
                  <span className="spec-icon-circle">
                    <Globe size={14} strokeWidth={1.8} />
                  </span>
                  <span className="spec-text">{plan.languages}</span>
                </div>
              </div>

              {/* Light Horizontal Divider */}
              <div className="pricing-divider" />

              {/* 2x2 Feature Checkmark Grid with Standalone Green Tick */}
              <div className="pricing-features-grid">
                {plan.features.map((feat, idx) => (
                  <div key={idx} className="feature-grid-item">
                    <Check size={16} color="#10B981" strokeWidth={2.5} className="feature-check-icon" />
                    <span>{feat.label}</span>
                  </div>
                ))}
              </div>

              {/* Apple Pill CTA Footer */}
              <div className="pricing-card-footer">
                <button
                  type="button"
                  className={`pricing-pill-btn ${plan.popular ? "primary-coral" : "secondary-white"}`}
                >
                  <span>Get started</span>
                  <ArrowRight size={15} className="pricing-btn-arrow" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Pricing;